import { FaTwitter } from 'react-icons/fa'

import { POOL_ADDRESS } from '../../dappy/constants'

const FooterLink = ({ href, label, icon: Icon }) => {
  return (
    <li className="inline-block pl-6">
      <a
        href={href}
        target="_blank"
        rel="noreferrer noopener"
        className="text-gray-500 hover:text-blue-600 transition duration-150 ease-in-out"
      >
        <span className="sr-only">{label}</span>
        <Icon className="w-5 h-5 fill-current" />
      </a>
    </li>
  )
}

// <ul className="flex justify-center md:order-2">
// <FooterLink
// href={'https://twitter.com/swordybot'}
// icon={FaTwitter}
// label="Twitter"
// />
// </ul>
const Footer = () => (
  <footer className="container py-12 md:flex md:items-center md:justify-between max-w-7xl mx-auto px-4 sm:px-6">
    <div className="mt-8 md:mt-0 md:order-1">
      <p className="text-center text-sm md:text-base text-gray-700">
        ©{new Date().getFullYear()} RICE Farm -{' '}
        <a
          href={`https://blockscout.com/poa/xdai/address/${POOL_ADDRESS}/contracts`}
        >
          {POOL_ADDRESS.slice(0, 6)}...
        </a>
      </p>
    </div>
  </footer>
)
export default Footer
